import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5978e1b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["type", "size"]

interface props {
    size: any;
    type: any;
    classBtn: any;
    icon: any;
    label: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SaveData',
  props: {
    size: { default: '' },
    type: { default: '' },
    classBtn: { default: 'btn-ad-save-data' },
    icon: { default: '' },
    label: { default: '' }
  },
  setup(__props: any) {

const propsData = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.classBtn),
    type: _ctx.type,
    size: _ctx.size
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(_ctx.icon)
    }, null, 2),
    _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.label)), 1)
  ], 10, _hoisted_1))
}
}

})